export default __webpack_public_path__ + "static/media/oe08.2491574c.jpg";